import urlService from 'src/app/services/urlService';

const TicketUrlService = {
    batchUploadTickets(eventId: string) {
        return urlService.getTickets(`batch-upload-tickets/event/${eventId}`);
    },
};

export default TicketUrlService;
